import { render, staticRenderFns } from "./CardAudio.vue?vue&type=template&id=46ccd8a0&scoped=true"
import script from "./CardAudio.vue?vue&type=script&lang=js"
export * from "./CardAudio.vue?vue&type=script&lang=js"
import style0 from "./CardAudio.vue?vue&type=style&index=0&id=46ccd8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ccd8a0",
  null
  
)

export default component.exports